import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useChatSearch = (searchQuery, enabled = false) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["chatSearch", tenantVal, searchQuery],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(`${tenantVal}/chat/search`, {
        params: { q: searchQuery },
      });
      return response.data || [];
    },
    enabled: !!tenantVal && !!searchQuery && enabled,
    meta: { errorMessage: "Error searching messages" },
  });
};